export default __webpack_public_path__ + "static/media/lavelendmsg.350613e8.png";